import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ClientService } from 'src/app/shared/services/client.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-open-finance-dialog',
  templateUrl: './open-finance-dialog.component.html',
  styleUrls: ['./open-finance-dialog.component.scss']
})
export class OpenFinanceDialogComponent implements OnInit, OnDestroy {

  confirmResult: Subject<any>
  account: any = {}
  step = 1
  organizations: any = []
  consent: any = {}
  intervalId: any
  organization: any = {}
  accounts: any = []
  bodyHeight: number = window.innerHeight / 3

  constructor(
    private clientService: ClientService,
    private commonService: CommonService,
    public modalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.confirmResult = new Subject()
    this.getLinaOrganizations()
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId)
  }

  async getLinaOrganizations() {
    const $res = await this.clientService.getLinaOrganizations()
    this.organizations = $res.organizations
  }

  async selectOrganization(item: any) {
    let body = {
      authorization_uuid: item?.authorization_uuid,
      organization_uuid: item?.organization_uuid,
      consent_status: 'authorized'
    }

    const $res = await this.clientService.getOpenFinanceConsents(body)
    this.consent = $res.consents.find(x => x)
    if (!this.consent) {
      delete body.consent_status
      this.consent = await this.clientService.getLinaConsent(body)
    }

    this.changeStep(2)
  }

  onRedirect() {
    window.open(this.consent?.consent_url_redirect || this.consent?.consent_user_url_redirect)
    this.modalRef?.hide()
  }

  onChangeOrganization() {
    this.organization = {}
    this.changeStep(1)
  }

  changeStep(step) {
    this.step = step
  }

  close(option) {
    this.confirmResult.next(option)
    this.modalRef.hide()
  }
}
